import { render } from "./show-date-time.vue?vue&type=template&id=3f439f98&scoped=true"
import script from "./show-date-time.vue?vue&type=script&lang=js"
export * from "./show-date-time.vue?vue&type=script&lang=js"

import "./show-date-time.vue?vue&type=style&index=0&id=3f439f98&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f439f98"]])

export default __exports__